// Vendor imports
const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
const { ago } = require('shared/date')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const UserAvatar = require('client-v2/common/components/user-avatar')
const { registerEventHandlerShim } = require('client-v2/common/components/utils')
const { userProfileHref } = require('client-v2/common/models/user/actions')

const bem = BemEntity('ArticleProfileCommentsItem')

const eventHandlerKeys = [
  'onDeleteClick',
  'onReportClick'
]

class ArticleProfileCommentsItem extends React.PureComponent {
  constructor(props) {
    super(props)

    // Ensure function references do not change between render calls
    eventHandlerKeys.forEach(key => registerEventHandlerShim(this, key))
    this.onUserClick = () => {
      // Open the user profile of the comment's user (not yourself)
      this.props.onUserClick({ user: this.props.comment })
    }
  }

  renderDeleteButton() {
    const { comment, user } = this.props
    if (!user.loggedIn || comment['user_id'] !== user.id) {
      return null
    }
    return (
      tag('button', {
        className: classNames(
          bem.element('header-item'),
          bem.element('button', 'delete')
        ),
        title: 'Delete this comment',
        onClick: this.onDeleteClick
      })
    )
  }

  renderReportButton() {
    const { comment, user } = this.props
    if (!user.loggedIn || comment['user_id'] === user.id) {
      return null
    }
    return (
      tag('button', {
        className: classNames(
          bem.element('header-item'),
          bem.element('button', 'report')
        ),
        title: 'Report this comment',
        onClick: this.onReportClick
      })
    )
  }

  renderTimestamp() {
    const { comment } = this.props
    const createdAt = new Date(comment['created_at'])
    return (
      tag('time', {
        className: classNames(
          bem.element('header-item'),
          bem.element('time')
        ),
        dateTime: createdAt.toISOString()
      },
        ago(createdAt)
      )
    )
  }

  renderUserIcon() {
    return tag(UserAvatar, {
      className: bem.element('user-icon'),
      href: true,
      user: this.props.comment,
      onClick: this.onUserClick
    })
  }

  renderUsername() {
    const { comment } = this.props
    return (
      tag('a', {
        className: classNames(
          bem.element('header-item'),
          bem.element('username')
        ),
        href: userProfileHref(comment),
        onClick: this.onUserClick
      },
        `@${comment.username}`
      )
    )
  }

  render() {
    const { comment } = this.props
    return (
      tag('li', {
        className: classNames(
          this.props.className,
          bem.block()
        )
      },
        this.renderUserIcon(),
        tag('div', {
          className: bem.element('content')
        },
          tag('div', {
            className: bem.element('header')
          },
            this.renderUsername(),
            this.renderTimestamp(),
            this.renderReportButton(),
            this.renderDeleteButton()
          ),
          tag('p', {
            className: bem.element('text'),
            dangerouslySetInnerHTML: { __html: comment.text }
          })
        )
      )
    )
  }
}

ArticleProfileCommentsItem.propTypes = {
  // Values
  article: PropTypes.object.isRequired, // TODO PropTypes.shape
  className: PropTypes.string,
  comment: PropTypes.object.isRequired, // TODO PropTypes.shape
  user: PropTypes.object.isRequired, // TODO PropTypes.shape
  // Callbacks
  onDeleteClick: PropTypes.func,
  onReportClick: PropTypes.func,
  onUserClick: PropTypes.func
}

module.exports = ArticleProfileCommentsItem
